module.exports = __webpack_public_path__ + "static/logo-ec658ffd19fed839d19b1d733c42405a.png";